// extracted by mini-css-extract-plugin
export default {"dnb_header_search_button":"SearchButton-module--dnb_header_search_button--17bb8"};